<template>
  <div id="mapHljEchart" :style="{ width: '700px', height: '750px' }"></div>
</template>

<script>
import * as echarts from "echarts";
import {onMounted, onUnmounted } from 'vue'
import hljDataJson from '../static/黑龙江省.json'
export default {
  name: "echartsBox",
  data(){
    return {
      hljDataJson
    }
  },
  setup() {
    /// 声明定义一下echart
    let echart = echarts;
    onMounted(() => {
      mapEchart(hljDataJson);
    });

    onUnmounted(() => {
      echart.dispose();
    });
	
    // 基础配置一下Echarts
    function mapEchart(data) {
      let chart = echart.init(document.getElementById("mapHljEchart"));
      echarts.registerMap('HLJ', data);
      // 把配置和数据放这里
      chart.setOption({
      backgroundColor:'',
      label: {
          emphasis: {
              show: false
          }
      },
      tooltip: {
       trigger: 'item',
       show: true,
       padding: 0,
       backgroundColor: 'rgba(0,0,0,0.5)',
       formatter: function(params){
        let str = `<div class="tip">
        <p>${params.name}:<span>${params.data.obj.data1}件</span></p>
        <p>电子元器件:<span>${params.data.obj.data2}件</span></p>
        <p>电子测量仪器:<span>${params.data.obj.data3}件</span></p>
        <p>电子雷达设备:<span>${params.data.obj.data4}件</span></p>
        <p>广播电视设备:<span>${params.data.obj.data5}件</span></p>
        <p>电子专用设备:<span>${params.data.obj.data6}件</span></p>
        </div>`
        return str;
       }
      },
      series: [
        {
          type: 'map',
          map: 'HLJ',
          zoom: 1.2,
          giIndex: 0,
          label: {
            show: true,
            normal: {
              show: true,
              textStyle: {
                fontSize: 16,
                color: '#fff',
              }
            }
          },
          data: [
            { name: '大兴安岭地区', value: 20057.34, obj: {data1: 9, data2: 5,data3: 0,data4: 0, data5:4, data6: 0}, itemStyle:{normal:{areaColor:'#2648ff'}}},
            { name: '黑河市', value: 15477.48, obj: {data1: 57, data2: 15,data3: 5,data4: 0, data5:37, data6: 0},itemStyle:{normal:{areaColor:'#2648ff'}}},
            { name: '齐齐哈尔市', value: 31686.1, obj: {data1: 147, data2: 106,data3: 24,data4: 0, data5:13, data6: 4}, itemStyle:{normal:{areaColor:'#A7CEFC'}}},
            { name: '哈尔滨市', value: 6992.6, obj: {data1 : 3958, data2: 3324, data3: 307,data4: 110,data5: 151, data6:66,},itemStyle:{normal:{areaColor:'#2C6AE8'}}},
            { name: '鸡西市', value: 44045.49, obj: {data1: 36, data2: 31,data3: 4,data4: 0, data5:1, data6: 0},itemStyle:{normal:{areaColor:'#2C6AE8'}}},
            { name: '鹤岗市', value: 40689.64, obj: {data1: 22, data2: 12,data3: 1,data4: 0, data5:9, data6: 0},itemStyle:{normal:{areaColor:'#2C6AE8'}}},
            { name: '双鸭山市', value: 37659.78, obj: {data1: 24, data2: 17,data3: 5,data4: 0, data5:2, data6: 0},itemStyle:{normal:{areaColor:'#2C6AE8'}}},
            { name: '大庆市', value: 45180.97, obj: {data1: 265, data2: 212,data3: 41,data4: 1, data5:11, data6: 1},itemStyle:{normal:{areaColor:'#2C6AE8'}}},
            { name: '伊春市', value: 55204.26,obj: {data1: 8, data2: 6,data3: 1,data4: 1, data5:0, data6: 0},itemStyle:{normal:{areaColor:'#669EF5'}}},
            // { name: '伊春市', value: 21900.9, obj: {data1: 0, data2: 30,data3: 20,data4: 10, data5:223, data6: 22},itemStyle:{normal:{areaColor:'#2C6AE8'}}},
            { name: '七台河市', value: 4918.26,obj: {data1: 33, data2: 30,data3: 0,data4: 0, data5:3, data6:0},itemStyle:{normal:{areaColor:'#2C6AE8'}}},
            { name: '牡丹江市', value: 5881.84,obj: {data1: 69, data2: 53,data3: 6,data4: 0, data5:8, data6: 2},itemStyle:{normal:{areaColor:'#2C6AE8'}}},
            { name: '绥化市', value: 4178.01,obj: {data1: 48, data2: 40,data3: 2,data4: 0, data5:5, data6: 1},itemStyle:{normal:{areaColor:'#2C6AE8'}}},
            { name: '佳木斯市', value: 4178.01,obj: {data1: 72, data2: 57,data3: 7,data4: 0, data5:8, data6: 0},itemStyle:{normal:{areaColor:'#2648ff'}}},
          ],
        }
      ]
      });
      window.onresize = function() {
        //自适应大小
        chart.resize();
      };
    }
    return { mapEchart};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.total{
  display: flex;
  align-items: center;
  justify-content: center;
}
.num{
  display: flex;
  color: #fff;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.num p{
  font-size: 24px;
}
.total{
  border-style: solid;
  border-width: 1px;
  border-color: #088DF2;
  border-radius: 10px;
  box-sizing: border-box;
  box-shadow: 0px 0px 10px 1px #088df2;
  padding: 12px;
}
.stats {
  display: flex;
  flex-direction: column;
}
.stats div{
    border-style: solid;
    border-width: 1px;
    border-color: #088DF2;
    border-radius: 10px;
    box-sizing: border-box;
    box-shadow: 0px 0px 10px 1px #088df2;
    padding: 15px 24px;
    color: #fff;
}
/deep/div.tip{
  padding: 10px 15px;
}
/deep/div.tip p{
  line-height: 30px;
  text-align: right;
  color: #fff;
  font-weight: 600;
}
/deep/div.tip p span{
  padding-left: 20px;
}
/deep/.tip p:nth-child(1){
 color: #ef9015;
}
</style>
